import { invokeUpdateResourceAllocationForRequestsAggregateCache } from '~/modules/resourcing/enhancers/updateAllocationTotalsCache';
import { useUpdateResourceAllocationInternal } from '~/modules/resourcing/hooks/useUpdateResourceAllocation';
import useResourcingChartToolbarContext from './useResourcingChartToolbarContext';

export const useUpdateResourceAllocationForRequest = () => {
  const {
    isResourceActualModeEnabled,
    isShowColumnarTotalsEnabled
  } = useResourcingChartToolbarContext();

  return useUpdateResourceAllocationInternal({
    isResourceActualModeEnabled,
    refetchQueries: isShowColumnarTotalsEnabled
      ? ['getProjectTotalsBySlug']
      : [],
    invokeUpdateFunction: invokeUpdateResourceAllocationForRequestsAggregateCache
  });
};
